import { Grid } from "@material-ui/core";
import clsx from "clsx";
import { MentorTipIcon } from "../../shared/icons/gamePlan";
import { mentorTipStyles } from "./mentor-tip.styles";

interface MentorTipProps {
  className?: string;
  title: JSX.Element;
  details?: JSX.Element;
  variant?: "success" | "error";
  icon?: JSX.Element;
}

export const MentorTip = ({
  className,
  title,
  details,
  variant,
  icon,
}: MentorTipProps) => {
  const classes = mentorTipStyles();

  return (
    <Grid
      item
      xs={12}
      className={clsx(classes.container, {
        [classes.default]: !variant,
        [classes.success]: variant === "success",
        [classes.error]: variant === "error",
        [className]: !!className,
      })}
    >
      <div className={classes.mentorTipDetails}>
        <div className={classes.iconContainer}>{icon || <MentorTipIcon />}</div>
        <div className={classes.details}>
          <div className="header">{title}</div>
          {details && (
            <div className={classes.body} data-testid="description">
              {details}
            </div>
          )}
        </div>
      </div>
    </Grid>
  );
};
